/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Org_OverviewInputs */

const cs_portals_org_overview = /** @type {(inputs: Portals_Org_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync portálů kanceláře`)
};

const en_portals_org_overview = /** @type {(inputs: Portals_Org_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office portal sync`)
};

/**
* | output |
* | --- |
* | "Office portal sync" |
*
* @param {Portals_Org_OverviewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_org_overview = /** @type {((inputs?: Portals_Org_OverviewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Org_OverviewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_org_overview(inputs)
	return cs_portals_org_overview(inputs)
});